<template>
  <div class="page">
    <div class="bg-img">
      {{errMsg}}
    </div>
  </div>
</template>
<script>
  export default {
    name: 'errmsg',
    props: {
      errMsg: {
        type: String
      }
    },
  }

</script>
<style scoped>
  .page {
    background-color: #efeff1;
    width: 100vw;
    height: 100vh;
  }

  .bg-img {
    background-image: url("/static/img/warning1.png");
    background-size: 100%;
    background-position-y: 60px;
    background-repeat: no-repeat;
    width: 250px;
    height: 460px;
    margin: auto;
    padding: 260px 120px 0 120px;
    color: #999;
    text-align: center;
    font-weight: 600;
  }

  @media (max-width: 767px) {
    .bg-img {
      background-position-y: 60px;
      width: 200px;
      height: 180px;
      padding: 180px 55px 0 45px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/errmsg.vue